var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 402,
    viewBox: "0 0 262 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 402.001C16.0673 392.365 36.0594 384.122 49.8303 373.261C65.1128 361.207 77.3212 342.805 88.4221 327.03C103.205 306.023 116.119 283.214 132.729 263.54C156.531 235.348 190.664 211.02 226.832 207.01C263 203 263 205.001 263 205.001",
    stroke: "#C9C1AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263 1.5C228.5 34 222.254 41.6432 208.602 74.4557C200.418 94.1261 197.843 108.666 195.237 127.348C186.448 190.37 138.274 229.695 97.1547 273.679C68.5865 304.238 47 359.867 47 402",
    stroke: "#F5EAD2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.32b54ac85bbe33001ba10650ac2933e9.svg";
export { ForwardRef as ReactComponent };